<template>
  <div class="UseCase-card">
    <img class="UseCase-card__image" :src="image" />
    <div class="UseCase-card__info">
      <h3 class="UseCase-card__info-title"> {{ title }}</h3>
      <p class="UseCase-card__info-description">{{ description }}</p>
      <div class="UseCase-card__info-link">
        <router-link :to="url">
          Learn more
        </router-link>
        <font-awesome-icon :icon="['fas', 'arrow-right']"/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'UseCaseCard',
  props: {
    image: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.UseCase-card {
  margin: 15px 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transition: .2s ease-in-out;
  min-width: 367px;
  height: 559px;
  background: #FFFFFF;
  border: 1px solid #F2F2F2;
  box-shadow: 0 15px 30px -10px rgba(21, 17, 71, 0.03);
  border-radius: 24px;
  overflow: hidden;
  &__image {
    width: 100%;
    height: 280px;
  }
  &__info {
    padding: 30px;
    color: $color;
    &-title {
      font-weight: bold;
      font-size: 32px;
      line-height: 110%;
      margin-bottom: 20px;
    }
    &-description {
      font-size: 18px;
      line-height: 150%;
    }
    &-link {
      position: absolute;
      left: 30px;
      bottom: 30px;
      a {
        font-weight: 600;
        font-size: 24px;
        line-height: 130%;
        margin-right: 20px;
        transition: .2s ease-in-out;
        color: $color;
        &:hover {
          margin-right: 35px;
        }
      }
    }
  }
  &:hover {
    box-shadow: 0 15px 30px -10px rgba(21, 17, 71, 0.1);
    margin-top: 0;
  }
}
</style>
